import styles from "../styles/pages/SignIn.module.css";
import componentStyles from "../styles/components/SignIn.module.css";
import { useState } from "react";
import { useSignInEmailPassword } from "@nhost/react";
import { Navigate } from "react-router-dom";
import Input from "../components/Input";
import Spinner from "../components/Spinner";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const {
    signInEmailPassword,
    isLoading,
    isSuccess,
    needsEmailVerification,
    isError,
    error,
  } = useSignInEmailPassword();

  const handleOnSubmit = (e) => {
    e.preventDefault();
    signInEmailPassword(email, password);
  };

  if (isSuccess) {
    return <Navigate to="/" replace={true} />;
  }

  const disableForm = isLoading || needsEmailVerification;

  return (
    <div className={styles.container} id="container">
      <div className={componentStyles.card}>
        <div className={componentStyles["logo-wrapper"]}>
          <img src={process.env.PUBLIC_URL + "icon.png"} alt="logo" />
        </div>

        {needsEmailVerification ? (
          <p className={componentStyles["verification-text"]}>
            Please check your mailbox and follow the verification link to verify
            your email.
          </p>
        ) : (
          <form onSubmit={handleOnSubmit} className={componentStyles.form}>
            <Input
              type="email"
              label="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={disableForm}
              required
            />
            <Input
              type="password"
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={disableForm}
              required
            />

            <button
              type="submit"
              disabled={disableForm}
              className={componentStyles.button}
            >
              {isLoading ? <Spinner size="sm" /> : "Sign in"}
            </button>

            {isError ? (
              <p className={componentStyles["error-text"]}>{error?.message}</p>
            ) : null}
          </form>
        )}
      </div>
    </div>
  );
};

export default SignIn;
